<template>
  <tr>
    <th scope="row">{{ voucherTitle }}</th>
    <td v-for="(item, index) in voucherItem" :key="index">
      <span :class="tdClass(item)" v-html="tdText(item)"></span>
    </td>
  </tr>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import { getTextBreaks } from '@/common/utils/string-manipulation/get-text-breaks'

  const props = defineProps({
    voucher: {
      type: Object,
      default: () => ({}),
    },
  })

  const voucherTitle = computed(() => getTextBreaks(props.voucher?.title) ?? '')
  const voucherItem = computed(() => props.voucher?.voucherItem ?? [])

  const renderLogoImage = (text) => {
    if (!text) {
      return ''
    }

    const logoRegExp = /(wavve|tving)_logo (.+)/gi

    return text
      .replace(
        logoRegExp,
        (_, logo, label) =>
          `<em class="b-box"><i class="${logo}">${logo}</i><span class="text">${label}</span></em>`,
      )
      .replace('/\n/g', '')
  }

  const tdClass = (text) => {
    const [itemText] = Object.values(text)
    if (itemText === 'check' || itemText === Boolean(true)) {
      return 'icon-check'
    }

    if (itemText === '' || itemText === Boolean(false)) {
      return 'icon-uncheck'
    }
  }

  const tdText = (text) => {
    const [itemText] = Object.values(text)
    if (itemText === 'check' || itemText === Boolean(true)) {
      return '가능'
    }

    if (itemText === '' || itemText === Boolean(false)) {
      return '불가능'
    }

    if (itemText?.match(/(wavve|tving)_logo/gi)) {
      return renderLogoImage(itemText)
    }

    return getTextBreaks(itemText)
  }
</script>
<style lang="scss" scoped>
  th,
  td {
    border-bottom: 1px #2f2f2f solid;
  }
</style>
